// extracted by mini-css-extract-plugin
module.exports = {"uploadFileButton":"PersonalPayLinkCreate_uploadFileButton__2C2XL","action":"PersonalPayLinkCreate_action__lKOIw"};